"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Thiana API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfEmbeddedCustomer = instanceOfEmbeddedCustomer;
exports.EmbeddedCustomerFromJSON = EmbeddedCustomerFromJSON;
exports.EmbeddedCustomerFromJSONTyped = EmbeddedCustomerFromJSONTyped;
exports.EmbeddedCustomerToJSON = EmbeddedCustomerToJSON;
/**
 * Check if a given object implements the EmbeddedCustomer interface.
 */
function instanceOfEmbeddedCustomer(value) {
    if (!('customer_external_id' in value) || value['customer_external_id'] === undefined)
        return false;
    if (!('id' in value) || value['id'] === undefined)
        return false;
    return true;
}
function EmbeddedCustomerFromJSON(json) {
    return EmbeddedCustomerFromJSONTyped(json, false);
}
function EmbeddedCustomerFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'customer_external_id': json['customer_external_id'],
        'id': json['id'],
    };
}
function EmbeddedCustomerToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        'customer_external_id': value['customer_external_id'],
        'id': value['id'],
    };
}
